import type { FC } from 'react'
import React from 'react'
import { getNumberString } from '../../utils/numbers'
import type { Props } from './types'

export const NumberString: FC<Props> = ({ value }) => {
  return <>{getNumberString(value)}</>
}
